import axios from 'axios';

// Public onboarding API (no auth). Powers the welcome page and the
// "browse newest policies / documents / terms per app" view.
export default {
  // Invite + full per-app document catalogue, by signup token.
  getWelcome(token) {
    return axios.get(`/api/v1/public/welcome/${token}`);
  },
  // The per-app catalogue on its own.
  getApps() {
    return axios.get('/api/v1/public/apps');
  },
  // Build a viewable/downloadable URL for a published document.
  documentUrl(doc, { download = false } = {}) {
    if (doc.external_url) return doc.external_url;
    if (!doc.download_path) return null;
    return download ? `${doc.download_path}?disposition=attachment` : doc.download_path;
  }
};
